import { siteSelectors } from 'src/app/shared/site/site.selectors'
import { Site } from 'src/app/shared/site/site'
import { UserAccessRightService } from 'src/app/shared/services/user-access-rights.service'
import { BreadCrumbActions } from './../../../shared/components/breadcrumb/breadcrumb.actions'
import { Observable } from 'rxjs'
import { map, startWith, take, withLatestFrom } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'

import { configurationOptionSelectors } from '../configuration-option.selectors'
import { Router } from '@angular/router'
import { environment } from 'src/environments/environment'
import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { persistentUserRoleSelectors } from '../../role/user-role/persistent-user-role/persistent-user-role.selector'

@Component({
  selector: 'configuration-option-site-settings',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class SiteSettingsComponent implements OnInit {
  public isLoading$: Observable<boolean>
  public activeTab: string = 'general.categoryDescription'
  public routerlink: string = 'category-description'
  public arrayTabMenuObjects: any[] = []
  public moduleConfigs: any
  public isMultiDayEnabled = environment.moduleConfigs?.saleModule?.isActive
    ? environment.moduleConfigs?.saleModule?.multiDayFlow
    : false
  public accessRights = AccessRights
  public operationInternalShow: boolean
  public locationShow: boolean
  public currentSite$: Observable<Site>
  constructor(
    private store: Store<AppState>,
    private router: Router,
    public accessRightService: UserAccessRightService
  ) {}

  ngOnInit() {
    this.moduleConfigs = environment.moduleConfigs
    this.currentSite$ = this.store
      .select(persistentUserRoleSelectors.selectSelectedUserRole)
      .pipe(
        withLatestFrom(this.store.select(siteSelectors.selectAll)),
        map(([userRole, sites]) => sites.find((s) => s.id == userRole.siteId))
      )
    this.isLoading$ = this.store
      .select(configurationOptionSelectors.selectIsLoading)
      .pipe(startWith(false))
    this.store.dispatch(
      BreadCrumbActions.initHistory({
        pageName: 'general.siteSettings',
        url: '/configuration-options/site-settings/category-description',
        titleName: ['general.showLess']
      })
    )

    this.router.navigateByUrl(
      'configuration-options/site-settings/category-description'
    )
    this.arrayTabMenuObjects = [
      {
        name: 'category-description',
        jsonTranslation: 'general.categoryDescription',
        show: true,
        iconName: 'align-center'
      }
    ]
  }
  setActiveTab(tab) {
    this.activeTab = tab
    this.routerlink = tab.split('.').pop()

    this.store.dispatch(
      BreadCrumbActions.addPageToHistory({
        pageName: tab,
        url: this.router.url,
        titleName: ['general.showLess']
      })
    )
    this.store.dispatch(
      BreadCrumbActions.filterBreadCrumb({
        pageName: tab,
        url: this.router.url,
        titleName: ['general.showLess']
      })
    )
  }
}
